import { render, staticRenderFns } from "./AddBuilding.vue?vue&type=template&id=6149b078&"
import script from "./AddBuilding.vue?vue&type=script&lang=js&"
export * from "./AddBuilding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports